<template>
  <fin-header-footer-container footer-color="#fff" vertical-centered>
    <template #default="{ footerHeight }">
      <v-row justify="center" no-gutters>
        <v-col style="max-width: 520px; text-align: center;">
          <fin-advanced-elevated-box :buttons="buttons" :image="illu"
                                     @continueBtn="startOnboarding('continue', 'continue')"
                                     @dashboardBtn="showDashboard"
                                     @restartBtn="startOnboarding('restart', 'restart')"
                                     @startBtn="startOnboarding('continue', 'start')"
                                     :paddingPy="0"
                                     :class="$vuetify.breakpoint.xs ? 'pb-0' : 'pb-4'"
                                     :elevation-height="0"
                                     :style="{ maxWidth: '520px', margin: '0 auto', border: 'none', paddingLeft: $vuetify.breakpoint.xs ? '12px !important' : '', paddingRight: $vuetify.breakpoint.xs ? '12px !important' : ''}"
          >
            <template #title>
              <div class="mb-8" style="max-width: 400px; margin: 0 auto;">{{
                  authorized ? title_user : title_guest
                }}
              </div>
            </template>
            <template #content>
              <fin-lexicon-text v-if="false"
                                :text="authorized ? text_user : text_guest"
                                auto-solve
                                class="mt-8"/>
            </template>
          </fin-advanced-elevated-box>

          <v-btn v-if="authorized" text @click.capture.stop.prevent="logout">
            <span class="text-btn">Abmelden und später fortsetzen</span>
          </v-btn>

          <v-btn v-else text @click.capture.stop.prevent="login">
            <span id="fin-already-registered" class="text-btn">Du bist schon registriert? Anmelden</span>
          </v-btn>

        </v-col>
      </v-row>
    </template>
  </fin-header-footer-container>
</template>

<script>
import FinHeaderFooterContainer from '@/components/common/HeaderFooterContainer/index'
import FinAdvancedElevatedBox from '@/components/common/box/advancedElevatedBox/index'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import {mapActions, mapState} from 'vuex'
import AmplitudePush from "@/mixins/AmplitudePush"

export default {
  name: 'finOnboardingGetStarted',
  mixins: [AmplitudePush],
  components: {
    FinLexiconText,
    FinAdvancedElevatedBox,
    FinHeaderFooterContainer,
  },
  props: {
    existProcess: {
      type: Boolean
    },
    mode: {
      type: String
    }
  },
  data() {
    return {
      dialog: false,
      illu: require('@/assets/onboarding/getstarted/final-portfolio.svg'),
      text_user: 'Wir führen dich in drei Schritten zu deinem ersten Portfolio. So lernst du die finCraft-Anwendung am schnellsten kennen.',
      text_guest: 'Wir haben Schritt 1 zu deinem Portfolio bereits freigeschaltet. In 2 Minuten lernst du den Investor in dir kennen!',
      title_user: 'Dein erstes Wertpapier-Portfolio',
      title_guest: 'In drei Schritten zu deinem Wertpapier-Portfolio',
    }
  },
  computed: {
    ...mapState('auth', {
      authorized: state => state.authorized
    }),
    buttons() {
      if (!this.existProcess) {
        return [{name: 'Los geht\'s', eventName: 'startBtn', class: 'btn-getting-started'}]
      } else {
        return [
          {name: 'Direkt zum Dashboard', eventName: 'dashboardBtn', class: 'btn-continue'},
          {name: 'Neu anfangen', eventName: 'restartBtn', class: 'btn-restart'}
        ]
      }
    }
  },
  methods: {
    ...mapActions('auth', ['signOut']),
    onClick: function (name, event) {
      this.$emit(name, event)
    },
    showDashboard() {
      this.pushToAmplitude({
        'event': 'fincraft_onboarding_starting',
        'placement': 'onboarding_getstarted',
        'step': 'goto_myFinHub',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$router.push({name: 'myFinHub'})
    },
    startOnboarding(toEmit, origBtn) {
      // toEmit takes the values continue or restart
      this.pushToAmplitude({
        'event': 'fincraft_onboarding_starting',
        'placement': 'onboarding_getstarted',
        'step': this.mode + "_" + origBtn,
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$emit(toEmit)
    },
    async logout() {
      await this.pushToAmplitude({
        'event': 'fincraft_onboarding_starting',
        'placement': 'onboarding_getstarted',
        'step': 'logout',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })

      await this.signOut()
      this.$router.push('/').catch(e => console.error("Onboarding Welcome: error loging out", e))
    },
    login() {
      this.pushToAmplitude({
        'event': 'fincraft_onboarding_starting',
        'placement': 'onboarding_getstarted',
        'step': 'login',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../../styles/variables.scss";

h1.step2 {
  font-family: $heading-font-family;
  font-size: 32px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}

p.step2 {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}

.button-text {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-dark;
}

.text-btn {
  height: 20px;
  font-weight: normal;
  text-decoration: underline
}

h4 {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
}
</style>
